
let styles = {
    container: {
      padding: '3%',
      display: 'flex',
      justifyContent: 'center',
    },
    table: {
        backgroundColor: '#dcdcdc',
        padding: '1%',
    },
    items: {
        padding: '1%',
        // display:'flex',
        // flexDirection:'row'
    },
    
    item_header: {
        fontWeight: 600,
        paddingLeft: '5%',
        width:'50%'
    },
    
    item_body: {
        padding: '6px ',
        width:'50%'
    },
    
    main_header: {
        padding: '1%',
        marginBottom: '3%',
    },

    input: {
        width: '50%',
        height: 25,
      },

    court_list: {
        padding: '1%',
        display: 'flex',
        flexDirection: 'row',
        justifyContent:'space-around',
        borderBottom: '1px solid black',
        width:'100%'
    },
    button_submit: {
        padding: '1%',
        justifyContent: 'center',
        display: 'flex',
        paddingTop: '6%',
    },

    cart_contents: {
      fontSize: '100%',
      textAlign: 'center',
    },
    cart: {
      margin: '3%',
      border:'1px solid grey',
      backgroundColor:'white',
    },
    cart_header: {
      paddingLeft: '1.5%',
      color: '#32B6A7',
      fontSize: '130%',
    },
    cart_rows : {
      paddingLeft:'1.5%',
    },

  }
  export default styles
  


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/addBulBooking/style.js